var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"pa-8 text-center"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.loadingMessage)}})]),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary","height":"8"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }